import { render, staticRenderFns } from "./DisplayConfig.vue?vue&type=template&id=04b4c3a8&scoped=true"
import script from "./DisplayConfig.vue?vue&type=script&lang=js"
export * from "./DisplayConfig.vue?vue&type=script&lang=js"
import style0 from "./DisplayConfig.vue?vue&type=style&index=0&id=04b4c3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4c3a8",
  null
  
)

export default component.exports